import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataVisualsComponent } from './data-visuals.component';
import { LoaderModule } from 'src/app/shared/components/loader/loader.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    DataVisualsComponent
  ],
  imports: [
    CommonModule,
    LoaderModule,
    ReactiveFormsModule
  ]
})
export class DataVisualsModule { }
